<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">Japan’s Pacific War:</h1>
<p class="title1">Personal Accounts of the Emperor’s Warriors</p>
<p class="authora1">Peter Williams</p>
<div class="img_containerpp">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?7e042d6c